export function FlashMessages({ flash }: { flash: { notice?: string; alert?: string } }) {
  if (!flash.notice && !flash.alert) return null

  return (
    <div className="mx-auto max-w-5xl px-4 pt-4">
      {flash.notice && (
        <div className="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
          {flash.notice}
        </div>
      )}
      {flash.alert && (
        <div className="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
          {flash.alert}
        </div>
      )}
    </div>
  )
}
